import {DBSchema} from 'idb';
import {FieldMinimal} from '@docma-mm-core/field/field';
import {Craft} from '@docma-mm-core/craft/craft';
import {Order} from '@docma-mm-core/order/order';
import {Contact} from '@docma-mm-core/contact/contact';
import {Classification} from '@docma-mm-core/classification/classification';
import {UserDefined} from '@docma-mm-core/user-defined/user-defined';
import {Status} from '@docma-mm-core/status/status';
import {Keyword} from '@docma-core/keyword/keyword';
import {Project} from '@docma-mm-core/project/project';
import {Layout} from '@docma-mm-core/layout/layout';
import {Structure} from '@docma-mm-core/structure/structure';
import {FaultDbEntity} from '@docma-mm-core/fault/fault-db.entity';
import {AttachmentFileDbEntity, FileDbEntity} from '@docma-mm-core/attachment/attachment-db.entity';
import {DocumentType} from '@docma-mm-core/document-type/document-type';
import {FaultPatch} from '@docma-mm-core/fault/patch/fault-patch';
import {Company} from '@docma-mm-core/company/company';
import {PlanData} from '@docma-mm-core/plan/plan';
import {Group} from '@docma-mm-core/group/group';


export enum MmProjectDbCollections {
  fields = 'fields',
  crafts = 'crafts',
  orders = 'orders',
  layouts = 'layouts',
  contacts = 'contacts',
  classifications = 'classifications',
  userDefineds = 'user-defineds',
  userPermissions = 'user-permissions',
  statuses = 'statuses',
  keywords = 'keywords',
  structures = 'structures',
  project = 'project',
  faults = 'faults',
  fault_patches = 'fault_patches',
  fault_patches_backup = 'fault_patches_backup',
  files = 'files',
  sync_files = 'sync_files',
  groups = 'groups',
  documentTypes = 'document-types',
  companies = 'companies',
  attributes = 'attributes',
  attributeGroups = 'attribute-groups',
  attributeGroups_files = 'attribute-groups_files',
  plans = 'plans',
  pins = 'pins',
  projectSettings = 'project-settings',
  writingSettings = 'writing-settings',
  delays = 'delays',
}


export interface MmProjectDbSchema extends DBSchema {
  [MmProjectDbCollections.project]: {
    key: string,
    value: Project,
  };
  [MmProjectDbCollections.fields]: {
    key: string,
    value: FieldMinimal,
  };
  [MmProjectDbCollections.crafts]: {
    key: string,
    value: Craft,
  };
  [MmProjectDbCollections.orders]: {
    key: string,
    value: Order,
  };
  [MmProjectDbCollections.contacts]: {
    key: string,
    value: Contact,
  };
  [MmProjectDbCollections.classifications]: {
    key: string,
    value: Classification[],
  };
  [MmProjectDbCollections.userDefineds]: {
    key: string,
    value: UserDefined[],
  };
  [MmProjectDbCollections.userPermissions]: {
    key: string,
    value: any,
  };
  [MmProjectDbCollections.statuses]: {
    key: string,
    value: Status,
  };
  [MmProjectDbCollections.keywords]: {
    key: string,
    value: Keyword,
  };
  [MmProjectDbCollections.layouts]: {
    key: string,
    value: Layout,
  };
  [MmProjectDbCollections.structures]: {
    key: string,
    value: Structure,
  };
  [MmProjectDbCollections.faults]: {
    key: string,
    value: FaultDbEntity,
  };
  [MmProjectDbCollections.fault_patches]: {
    key: string,
    value: FaultPatch,
    indexes: {
      fUid: FaultPatch['fUid'],
    }
  };
  [MmProjectDbCollections.groups]: {
    key: string,
    value: Group,
  };
  [MmProjectDbCollections.files]: {
    key: string,
    value: AttachmentFileDbEntity,
    indexes: {
      faultUid: AttachmentFileDbEntity['faultUid'],
    }
  };
  [MmProjectDbCollections.documentTypes]: {
    key: string,
    value: DocumentType,
  };
  [MmProjectDbCollections.companies]: {
    key: string,
    value: Company,
  };

  [MmProjectDbCollections.sync_files]: {
    key: string,
    value: FileDbEntity,
  };

  [MmProjectDbCollections.plans]: {
    key: string,
    value: PlanData,
  };

  [MmProjectDbCollections.projectSettings]: {
    key: string,
    value: any
  };

}
